import { useEffect, useState } from 'react';

import { Placement, PlacementStatus } from 'modules/placements/types';
import { usePlacementsManageContext } from '../../context/PlacementsManageContext';
import { PlacementsListContainer } from '../styles';
import { PlacementsListEntry } from './PlacementsListEntry';
import { Placements } from './styles';

export const PlacementsList = ({ placements }: { placements: Placement[] }) => {
  const [placementsInView, setPlacementsInView] = useState(placements);

  const { searchText, selectedPlacement, statusFilterTab, setSelectedPlacement } =
    usePlacementsManageContext();

  useEffect(() => {
    const filteredPlacements =
      placements?.filter((placement) => {
        if (
          (statusFilterTab === PlacementStatus.ACTIVE && placement.isArchived) ||
          (statusFilterTab === PlacementStatus.ARCHIVED && !placement.isArchived)
        )
          return false;
        if (!searchText) return true;

        return Object.entries(placement).some(([fieldName, val]) => {
          // If the field type is boolean we need to actually search the field name to match
          const isBooleanField = typeof val === 'boolean';
          const searchField = isBooleanField ? fieldName : val;
          return (
            (!isBooleanField || val) &&
            JSON.stringify(searchField).toLowerCase()?.includes(searchText.toLowerCase())
          );
        });
      }) || [];
    setPlacementsInView(filteredPlacements);
  }, [searchText, statusFilterTab, placements]);

  useEffect(() => {
    if (
      placementsInView?.length &&
      !placementsInView?.find((placement) => placement.id === selectedPlacement?.id)
    )
      setSelectedPlacement(placementsInView[0]);
  }, [placementsInView]);

  return (
    <PlacementsListContainer data-test="placements-list">
      <Placements>
        {placementsInView.map((placement) => (
          <PlacementsListEntry
            key={placement.id}
            onClick={() => setSelectedPlacement(placement)}
            placement={placement}
            isSelected={selectedPlacement?.id === placement.id}
          />
        ))}
      </Placements>
    </PlacementsListContainer>
  );
};
